import React, { useState } from 'react';
import '../styles/PsychologistCard.css';

function PsychologistCard({
  name,
  description,
  imageUrl,
  fullDescription,
  contactLink,
  topics,
  price
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {/* Основная карточка */}
      <article className="psychologist-card">
        <div className="psychologist-card__image">
          <img src={imageUrl} alt={name} />
        </div>

        <div className="psychologist-card__content">
          <h3>{name}</h3>

          <p className="psychologist-card__description">
            {description}
          </p>

          <button
            type="button"
            className="psychologist-card__more"
            onClick={() => setIsModalOpen(true)}
          >
            Узнать больше
          </button>
        </div>

        {contactLink && (
          <a
            href={contactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="psychologist-card__contact"
          >
            Написать психологу
          </a>
        )}
      </article>

      {/* Модальное окно */}
      {isModalOpen && (
        <div
          className="psychologist-modal"
          onClick={() => setIsModalOpen(false)}
        >
          <div
            className="psychologist-modal__card"
            onClick={(e) => e.stopPropagation()}
          >
          
            <div className="psychologist-modal__image">
              <img src={imageUrl} alt={name} />
            </div>

            <div className="psychologist-modal__content">
              <h3>{name}</h3>

              {fullDescription && (
                <p className="psychologist-modal__description">
                  {fullDescription}
                </p>
              )}

              {price && (
                <p className="psychologist-modal__price">
                  Формат работы: онлайн <span>{price}</span>
                </p>
              )}

              {topics && Array.isArray(topics) && topics.length > 0 && (
                <div className="psychologist-modal__topics">
                  <h4>Темы, с которыми можно обратиться:</h4>

                  <ul>
                    {topics.map((topic, index) => (
                      <li key={index}>
                        {topic.trim()}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="psychologist-modal__actions">
                {contactLink && (
                  <a
                    href={contactLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="psychologist-modal__contact"
                  >
                    Написать психологу
                  </a>
                )}

                <button
                  type="button"
                  className="psychologist-modal__close"
                  onClick={() => setIsModalOpen(false)}
                >
                  Закрыть
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PsychologistCard;